export default "__VITE_ASSET__DiniODla__"